import React, { useState, useContext } from 'react';
import type { ReactNode, CSSProperties } from 'react';
import { Link } from '@this/components/shared/ui/navigations/link';
import { createTheme } from '@this/constants/themes';
import CoreAppContext from '@this/components/core_app/core_app_context';

// 16進数色をrgbaに変換するヘルパー関数
const hexToRgba = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

interface CalendarLinkButtonProps {
  href?: string;
  onClick?: () => void;
  children: ReactNode;
}

export const CalendarLinkButton: React.FC<CalendarLinkButtonProps> = ({ href, onClick, children }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { serviceId } = useContext(CoreAppContext);
  const styledTheme = createTheme(serviceId);

  const hoverBorderColor = styledTheme.accentBorderColor;
  const normalBorderColor = hexToRgba(hoverBorderColor, 0.5);
  const normalBackgroundColor = '#fff';
  const hoverBackgroundColor = hexToRgba(hoverBorderColor, 0.04);

  const commonStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    width: '160px',
    padding: '0',
    textDecoration: 'none',
    border: `1px solid ${isHovered ? hoverBorderColor : normalBorderColor}`,
    borderRadius: '4px',
    backgroundColor: isHovered ? hoverBackgroundColor : normalBackgroundColor,
    color: styledTheme.linkColor,
    fontWeight: 700,
    cursor: 'pointer',
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  };

  const commonProps = {
    style: commonStyle,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    ...(onClick && { onClick }),
    ...(onClick ? {} : { href: href || '#', target: '_blank', rel: 'noopener noreferrer' })
  };

  return <Link {...commonProps}>{children}</Link>;
};
